angular.module('wbDashboard').controller('PlansDetailTaxplanControllerAurea', ['$scope', '$uibModal', '$filter', '$timeout', 'User', 'Account', 'PlanService', 'Message', function ($scope, $uibModal, $filter, $timeout, User, Account, PlanService, Message) {
    $scope.assetsPaused = 0;

    $scope.fundingStrategies = {
        "calculated_waterfall":"Wise Deposits",
        "user_waterfall":"Divide Deposits",
        "user_paused":"Pause Deposits"
    };

    PlanService.user.getSelectiveAssets().then(function(assetClasses) {
        $scope.assetClasses = assetClasses;
    });

    PlanService.user.getIraForecast().then(function(iraForecast) {
        $scope.iraForecast = iraForecast;
    });

    $scope.$watch(function() { return PlanService.user.getAutos(); }, function(autos) {
        $scope.autos = autos;
    });

    $scope.$watch('assetClasses', function(assetClasses) {
        if (assetClasses) {
            var assetsPaused = 0;
            var enabled;

            angular.forEach(assetClasses, function(ac) {
                enabled = $filter('filter')(ac.assets, {enabled: true}).length;
                if (enabled == 1 && ac.assets.length >= 2) {
                    //everything will have 2 if nothing paused, can't have 0
                    assetsPaused++;
                }
            });
            $scope.assetsPaused = assetsPaused;

        }
    }, true);

    PlanService.user.getWiseHarvestingData().then(function(whData) {
        $scope.whData = whData;
    });

    $scope.planDisableable = function() {
        var anyEnabled = false;
        if ($scope.featureInit) {
            angular.forEach($scope.featureInit, function (enabled, feature) {
                if (enabled && feature !== "rothconversions") {
                    anyEnabled = true;
                }
            });
        }
        return !anyEnabled;
    };

    $scope.confirmFeatures.initial = function() {
        if ($scope.$stateParams.fslug === 'taxpreferredaccount') {

            //want to add the plan page to the history stack go going back will go to it
            $scope.$state.go('^', {}, {location: 'replace'});
            $timeout(function() {
                $scope.$state.go('.feature.detail', {fslug: 'taxpreferredaccount'});
            });
        }
    };

    $scope.confirmFeatures.complete = function() {
        if ($scope.featureInit.securityselection) {
            $scope.$state.go('^.feature.detail', {fslug: 'securityselection'}, {location: 'replace'});
        } else {
            $scope.$state.go('^', {}, {location: 'replace'});
        }
    };

}]);
